<template>
  <v-layout align-content-start row wrap justify-start>
    <empty-alert :icon="'exclamation-circle'" :color="'orange accent-4'"
      v-if="userMP && userMP.id && (!userMP.cards || !userMP.default_card)">
      <div slot="content">
        <p>
          <strong>Você não tem nenhum cartão cadastrado</strong>
          <br>
          Para ativar o seu plano, é necessário que você cadastre um cartão de crédito.
        </p>
      </div>
      <div slot="actions">
        <v-btn round depressed large color="success" dark
          v-modal-trigger="'showUserFinancialCard'" :data-item="JSON.stringify(userMP)">
          <v-icon small left>fal fa-credit-card</v-icon>
          Cadastrar cartão
        </v-btn>
      </div>
    </empty-alert>
    <template v-else>
      <v-flex xs12>
        <v-layout class="section-header mx-2" row wrap align-content-center justify-center>
          <v-flex xs12>
            <v-layout row wrap align-center>
              <h1 class="section-title">
                <v-icon color="deep-orange darken-2">fal fa-headset</v-icon>
                Financeiro
              </h1>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <template>
        <v-flex xs12 md4 v-if="currentSubscription && currentSubscription.status !== 'cancelled' && currentSubscription.status !== 'finished'">
          <div class="section-box text-xs-center section-widget"
            v-if="currentSubscription.charges_detail && currentSubscription.charges_detail.last_charged_amount">
            <h2 class="section-title">PLANO</h2>
            <span class="number teal--text">
              {{ currentSubscription.charges_detail.last_charged_amount | formatCurrency }}
            </span>
            <div>
              <v-btn flat>
                <span class="grey--text">{{ currentPlan.description }}</span>
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md4 v-if="currentSubscription && currentSubscription.status !== 'cancelled' && currentSubscription.status !== 'finished'">
          <div class="section-box text-xs-center section-widget"
            v-if="currentSubscription.charges_detail && currentSubscription.charges_detail.last_charged_amount">
            <h2 class="section-title">Último pagamento</h2>
            <span class="number teal--text">
              {{ currentSubscription.charges_detail.last_charged_amount | formatCurrency }}
            </span>
            <div v-if="currentSubscription.charges_detail.last_charged_amount">
              <v-btn flat>
                <span class="grey--text">
                  {{ currentSubscription.charges_detail.last_charged_date | moment('DD/MM/Y') }}
                </span>
              </v-btn>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md4>
          <v-alert icon="fal fa-info-circle" :value="userMP && userMP.cards && userMP.cards.length && !userMP.default_card" type="error">
            É necessário deixar um cartão selecionado como principal.
          </v-alert>
          <div class="section-box text-xs-center section-widget">
            <template v-if="currentSubscription.charges_detail && currentSubscription.charges_detail.next_payment_date">
              <h2 class="section-title">Próximo vencimento</h2>
              <span class="number blue--text">
                {{ currentSubscription.charges_detail.next_payment_date | moment('DD/MM/Y') }}
              </span>
            </template>
            <div>
              <v-btn round color="primary" v-modal-trigger="'showUserFinancialCard'" :data-item="JSON.stringify(userMP)">
                <v-icon small left>fal fa-credit-card</v-icon>
                Gerenciar cartões
              </v-btn>
            </div>
          </div>
        </v-flex>
      </template>
      <!-- <admin-user-show-financial-transactions :userMP="userMP" /> -->
    </template>
    <user-financial-card />
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import router from '@/router'

import UserFinancialCard from '@/components/user/financial/UserFinancialCard'
import AdminUserShowFinancialTransactions from '@/components/admin/userShow/AdminUserShowFinancialTransactions'

export default {
  data: () => ({
    search: '',
    router: router,
    currentFilter: 'all',
    user: JSON.parse(localStorage.getItem('currentUser')),
    userMP: {},
    currentPlan: {},
    currentSubscription: {}
  }),

  methods: {
    loadTransactions () {
      EventBus.$emit('appLoading', true)

      // eslint-disable-next-line
      const path = API.userTickets

      axios.get(path).then(response => {
        this.transactions = response.data.transactions
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar as transações', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    },

    loadUserOnMP () {
      const params = {
        'email': this.user.email
      }
      const path = `${API.mpCustomers}/search`
      EventBus.$emit('appLoading', true)

      axios.post(path, params).then(payload => {
        const response = payload.data.customers.response
        if (response.results && response.results.length) {
          const customer = response.results[0]

          if (customer.email === this.user.email) {
            this.userMP = customer
            this.loadPlan()
            this.updateUserOnMp(this.userMP)
            EventBus.$emit('appLoading', false)
          } else {
            this.createUserOnMp(this.user)
          }
        } else {
          this.createUserOnMp(this.user)
        }
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar aluno no Mercado Pago', color: 'error' })
      })
    },

    createUserOnMp (user) {
      const path = `${API.mpCustomers}`
      const params = {
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        identification: {
          type: 'CPF',
          number: user.document_number
        }
      }

      axios.post(path, params).then(response => {
        if (response && response.data && response.data.customer.response) {
          this.userMP = response.data.customer.response
        }
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
        EventBus.$emit('showSnackbar', { message: 'Erro ao criar aluno no Mercado Pago', color: 'error' })
      })
    },

    updateUserOnMp (user) {
      const path = `${API.mpCustomers}/${user.id}`

      let params = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        identification: { number: this.user.document_number },
        metadata: {
          app_user_id: this.user._id
        }
      }

      if (user.metadata.subscription_id) params.metadata.subscription_id = user.metadata.subscription_id
      if (user.metadata.plan_id) params.metadata.plan_id = user.metadata.plan_id

      axios.put(path, params)
    },

    loadPlan () {
      if (!this.userMP || !this.userMP.metadata || !this.userMP.metadata.plan_id) return false
      const userPlanId = this.userMP.metadata.plan_id
      const path = `${API.mpPlans}/${userPlanId}`

      axios.get(path).then(response => {
        if (response && response.data && response.data.plan.response) {
          this.currentPlan = response.data.plan.response
        }
        this.loadSubscription()
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
        EventBus.$emit('showSnackbar', { message: 'Erro carregar o plano no Mercado Pago', color: 'error' })
      })
    },

    loadSubscription () {
      if (!this.userMP || !this.userMP.metadata || !this.userMP.metadata.subscription_id) return false
      const userSubscriptionId = this.userMP.metadata.subscription_id
      const path = `${API.mpSubscriptions}/${userSubscriptionId}`

      axios.get(path).then(response => {
        if (response && response.data) this.currentSubscription = response.data
      }).catch(errors => {
        EventBus.$emit('appLoading', false)
        EventBus.$emit('showSnackbar', { message: 'Erro carregar a assinatura no Mercado Pago', color: 'error' })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadUserOnMP')
  },

  created () {
    this.loadUserOnMP()
    EventBus.$on('loadUserOnMP', this.loadUserOnMP)
  },

  components: {
    UserFinancialCard,
    AdminUserShowFinancialTransactions
  }
}
</script>

<style src="../../assets/scss/components/overview.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/user/UserFinancial.vue